import React, { Fragment, useEffect, useState, useCallback } from 'react';
import './Home.css';
import { getProduct } from "../../actions/productAction";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../layout/Loader/Loader";
// IMPORTANT: Using Link for proper SPA navigation
import { Link } from "react-router-dom";

// import { CgMouse } from "react-icons/all";
// import { Card } from '@material-ui/core';
import ProductCard from './ProductCard.js';
import http from '../../interceptor/httpservice';
import DiscountPopup from '../DiscountPopup/discountPopup.js';
// import $ from "jquery"; // Note: If you have jQuery scripts, keep this commented unless truly needed here.
import bravelogo from "../../assets/img/logo/BRAVE-logo.png";
// import home2_category_3 from "../../assets/img/category/home2/category-3.jpg";
import banner_banner_3 from "../../assets/img/banner/banner-3.jpg";
import banner_banner_4 from "../../assets/img/banner/banner-4.jpg";
// import rash_guard_brave_blue_1 from "../../assets/img/products/rash_guard_brave_blue_1.png";
// import rash_guard_brave_blue_2 from "../../assets/img/products/rash_guard_brave_blue_2.png";
// import mma_gloves_brave from "../../assets/img/products/mma_gloves_brave.png";
import product_modal_1 from "../../assets/img/products/modal/product_modal_1.png";
import product_modal_2 from "../../assets/img/products/modal/product_modal_2.jpg";
import product_modal_sm_1 from "../../assets/img/products/modal/product_modal_sm_1.jpg";
import product_modal_sm_2 from "../../assets/img/products/modal/product_modal_sm_2.jpg";
import collection_topten from "../../assets/img/collection/top-ten.jpg";
import collection_rdx from "../../assets/img/collection/rdx.jpg";
import collection_greenhill from "../../assets/img/collection/green-hill.jpg";
import collection_accessories from "../../assets/img/collection/accessories.jpg";

// Each banner opens the shop filtered to what the banner shows (same order as the slides below)
const bannerLinks = [
    { to: "/Shop", label: "Shop lifestyle essentials" },
    { to: "/shop?gender=Men", label: "Shop men's streetwear" },
    { to: "/shop?category=TopTen%20Collection", label: "Shop the Top Ten Collection" },
    { to: "/shop?gender=Women", label: "Shop women's activewear" },
    { to: "/shop?gender=Men", label: "Shop men's essentials" },
];

const braveCollections = [
    // `category` must match the product category names exactly (see Shop collections filter)
    { title: "Top Ten Collection", image: collection_topten, to: "/shop?category=TopTen%20Collection" },
    { title: "RDX Collection", image: collection_rdx, to: "/shop?category=RDX%20Collection" },
    { title: "Green Hill Collection", image: collection_greenhill, to: "/shop?category=Green%20Hill%20Collection" },
    { title: "Shop Accessories", image: collection_accessories, to: "/shop?subcategory=Accessories" },
];

const isClothingProduct = (product) => String(product?.subcategory || "").trim().toLowerCase() === "clothing";

const Home = () => {
    const dispatch = useDispatch();
    const { loading, products } = useSelector(state => state.products);

    // PURE REACT SLIDER STATE AND LOGIC
    const [currentSlide, setCurrentSlide] = useState(0);
    const [homeBestSellerProducts, setHomeBestSellerProducts] = useState([]);
    const totalSlides = 5; // Based on your JSX structure

    // Memoize the dispatch function for Redux fetch
    const fetchProducts = useCallback(() => {
        dispatch(getProduct());
    }, [dispatch]);

    // 1. Core Slider Logic (Controlled by State)
    useEffect(() => {
        const nextSlide = () => {
            setCurrentSlide(prevSlide => (prevSlide + 1) % totalSlides);
        };

        const slideInterval = setInterval(nextSlide, 5000);

        return () => {
            clearInterval(slideInterval);

            // 🛑 AGGRESSIVE DOM CLEANUP 🛑
            // 1. Reset all slides to remove any zombie 'showing' classes
            const slides = document.querySelectorAll('#slides .slide');
            slides.forEach(slide => {
                slide.classList.remove('showing');
            });

            // 2. Attempt to destroy instances of common external slider libs
            // Note: If you identify the library (e.g., swiper, slick), customize this.
            if (window.$ && window.$('#slides').slick) {
                try {
                    window.$('#slides').slick('unslick'); // Example for Slick Slider
                } catch (e) {
                    console.error("Slick unslick failed:", e);
                }
            }

            // 3. Clear initial state to force re-render on remount
            setCurrentSlide(0);
        };

    }, []);

    // Logic to apply the 'showing' class based on React state
    useEffect(() => {
        const slides = document.querySelectorAll('#slides .slide');
        slides.forEach((slide, index) => {
            if (slide) {
                if (index === currentSlide) {
                    slide.classList.add('showing');
                } else {
                    slide.classList.remove('showing');
                }
            }
        });
    }, [currentSlide]);

    // 2. Redux Data Fetching
    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    useEffect(() => {
        const fetchHomeProducts = async () => {
            try {
                const response = await http.get('/api/v1/products?page=1&limit=1000');
                const allProducts = Array.isArray(response.data?.products) ? response.data.products : [];
                setHomeBestSellerProducts(allProducts.filter((product) => isClothingProduct(product)));
            } catch (error) {
                console.warn('Failed to fetch home product sections:', error);
                setHomeBestSellerProducts([]);
            }
        };

        fetchHomeProducts();
    }, []);

    // 3. Theme Initialization Fix (Runs on every mount/update to catch animations)
    useEffect(() => {
        // This attempts to re-initialize external scripts like WoW.js
        if (window.WOW) {
            new window.WOW().init();
        }

        // If your theme uses jQuery for initial setup, you might need:
        // if (window.jQuery && window.THEME_INIT_FUNCTION) {
        //     window.THEME_INIT_FUNCTION();
        // }
    });

    // Function to determine slide class name based on state
    const getSlideClassName = (index) => {
        // We use 'class' in the JSX but define 'className' here for React compatibility 
        // with the original theme classes.
        return `slide ${index === currentSlide ? 'showing' : ''}`;
    };

    const goToPreviousSlide = () => {
        setCurrentSlide(prevSlide => (prevSlide - 1 + totalSlides) % totalSlides);
    };

    const goToNextSlide = () => {
        setCurrentSlide(prevSlide => (prevSlide + 1) % totalSlides);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const getDailyRotatingProducts = (productList = [], count = 4) => {
        const validProducts = productList.filter((product) => product?._id);
        if (validProducts.length === 0) return [];

        const dayNumber = Math.floor(new Date().setHours(0, 0, 0, 0) / 86400000);
        const startIndex = dayNumber % validProducts.length;

        return Array.from({ length: count }, (_, index) => (
            validProducts[(startIndex + index) % validProducts.length]
        ));
    };

    const bestSellerPool = homeBestSellerProducts.length > 0
        ? homeBestSellerProducts
        : (products || []).filter((product) => isClothingProduct(product));
    const topSellingProducts = getDailyRotatingProducts(bestSellerPool, 4);

    return (
        <Fragment>
            {loading ? (
                <Loader />
            ) : (
                <Fragment>

                    {/* This is Nizar Work Area */}

                    <div>
                        <main>
                            {/* SLIDER WITH PURE REACT STATE CONTROL */}
                            <div className="home-slider-shell">
                                <ul id="slides">
                                    <li className={getSlideClassName(0)}>
                                        <Link
                                            to={bannerLinks[0].to}
                                            className="home-slide-link"
                                            aria-label={bannerLinks[0].label}
                                            tabIndex={currentSlide === 0 ? 0 : -1}
                                        />
                                        <div className="slider-area-rel">
                                            <div className="slider-active dot-style dot-style-1 dot-bottom-center">
                                                <div className=" single-slider-2 default-bg slider-height-2 d-flex align-items-center">
                                                    <div className="container container-2">
                                                        <div className="row align-items-center">
                                                            <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 pt-215 pb-10">
                                                                <div className="slider-content-2">
                                                                    <span className="s-subtitle s-subtitle-3 pb-25" data-animation="fadeInUp" data-delay=".3s"> </span>
                                                                    <h2 className="s-title s-title-2 pb-28" data-animation="fadeInUp" data-delay=".5s" aria-hidden="true"></h2>
                                                                    <div className="p-btn p-btn-5" data-animation="fadeInUp" data-delay=".9s">
                                                                        <br></br><br></br>
                                                                        {/* <a href="/Shop">Discover now</a> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className={getSlideClassName(1)}>
                                        <Link
                                            to={bannerLinks[1].to}
                                            className="home-slide-link"
                                            aria-label={bannerLinks[1].label}
                                            tabIndex={currentSlide === 1 ? 0 : -1}
                                        />
                                        <div className="slider-area-rel">
                                            <div className="slider-active dot-style dot-style-1 dot-bottom-center">
                                                <div className=" single-slider-2 default-bg slider-height-2 d-flex align-items-center">
                                                    <div className="container container-2">
                                                        <div className="row align-items-center">
                                                            <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 pt-215 pb-10">
                                                                <div className="slider-content-2">
                                                                    <span className="s-subtitle s-subtitle-3 pb-25" data-animation="fadeInUp" data-delay=".3s"> </span>
                                                                    <h2 className="s-title s-title-2 pb-28" data-animation="fadeInUp" data-delay=".5s" aria-hidden="true"></h2>
                                                                    <div className="p-btn p-btn-5" data-animation="fadeInUp" data-delay=".9s">
                                                                        <br></br><br></br>
                                                                        <a href="/Shop">Discover now</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className={getSlideClassName(2)}>
                                        <Link
                                            to={bannerLinks[2].to}
                                            className="home-slide-link"
                                            aria-label={bannerLinks[2].label}
                                            tabIndex={currentSlide === 2 ? 0 : -1}
                                        />
                                    <div className="slider-area-rel">
                                        <div className="slider-active dot-style dot-style-1 dot-bottom-center">
                                            <div className=" single-slider-2 default-bg slider-height-2 d-flex align-items-center">
                                                <div className="container container-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 pt-215 pb-10">
                                                            <div className="slider-content-2">
                                                                <span className="s-subtitle s-subtitle-3 pb-25" data-animation="fadeInUp" data-delay=".3s"> </span>
                                                                <h2 className="s-title s-title-2 pb-28" data-animation="fadeInUp" data-delay=".5s" aria-hidden="true"></h2>
                                                                <p className="s-desc pb-75" data-animation="fadeInUp" data-delay=".7s"></p>
                                                                <div className="p-btn p-btn-5" data-animation="fadeInUp" data-delay=".9s">
                                                                    <br></br><br></br>
                                                                    <a href="/Shop">Discover now</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </li>
                                    <li className={getSlideClassName(3)}>
                                        <Link
                                            to={bannerLinks[3].to}
                                            className="home-slide-link"
                                            aria-label={bannerLinks[3].label}
                                            tabIndex={currentSlide === 3 ? 0 : -1}
                                        />
                                    <div className="slider-area-rel">
                                        <div className="slider-active dot-style dot-style-1 dot-bottom-center">
                                            <div className=" single-slider-2 default-bg slider-height-2 d-flex align-items-center">
                                                <div className="container container-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 pt-55 pb-10">
                                                            <div className="slider-content-2">
                                                                <span className="s-subtitle s-subtitle-3 pb-25" data-animation="fadeInUp" data-delay=".3s"> </span>
                                                                <h2 className="s-title s-title-2 pb-28" data-animation="fadeInUp" data-delay=".5s" aria-hidden="true"></h2>
                                                                <div className="p-btn p-btn-5" data-animation="fadeInUp" data-delay=".9s">
                                                                    <br></br><br></br>
                                                                    <a href="/Shop">Discover now</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </li>
                                    <li className={getSlideClassName(4)}>
                                        <Link
                                            to={bannerLinks[4].to}
                                            className="home-slide-link"
                                            aria-label={bannerLinks[4].label}
                                            tabIndex={currentSlide === 4 ? 0 : -1}
                                        />
                                    <div className="slider-area-rel">
                                        <div className="slider-active dot-style dot-style-1 dot-bottom-center">
                                            <div className=" single-slider-2 default-bg slider-height-2 d-flex align-items-center">
                                                <div className="container container-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 pt-55 pb-10">
                                                            <div className="slider-content-2">
                                                                <span className="s-subtitle s-subtitle-3 pb-25" data-animation="fadeInUp" data-delay=".3s"> </span>
                                                                <h2 className="s-title s-title-2 pb-28" data-animation="fadeInUp" data-delay=".5s" aria-hidden="true"></h2>
                                                                <div className="p-btn p-btn-5" data-animation="fadeInUp" data-delay=".9s">
                                                                    <br></br><br></br>
                                                                    <a href="/Shop">Discover now</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </li>
                                </ul>

                                <button
                                    className="home-slider-nav home-slider-nav-prev"
                                    type="button"
                                    aria-label="Previous banner"
                                    onClick={goToPreviousSlide}
                                >
                                    <i className="fal fa-angle-left" aria-hidden="true"></i>
                                </button>
                                <button
                                    className="home-slider-nav home-slider-nav-next"
                                    type="button"
                                    aria-label="Next banner"
                                    onClick={goToNextSlide}
                                >
                                    <i className="fal fa-angle-right" aria-hidden="true"></i>
                                </button>

                                <div className="home-slider-dots" aria-label="Choose banner">
                                    {Array.from({ length: totalSlides }).map((_, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            className={`home-slider-dot ${index === currentSlide ? 'active' : ''}`}
                                            aria-label={`Show banner ${index + 1}`}
                                            aria-current={index === currentSlide ? 'true' : undefined}
                                            onClick={() => goToSlide(index)}
                                        />
                                    ))}
                                </div>
                            </div>


                            <section className="brave-collections" aria-label="Shop collections">
                                <div className="brave-collections-grid">
                                    {braveCollections.map((item) => (
                                        <Link key={item.title} to={item.to} className="brave-collection-card">
                                            <img src={item.image} alt={item.title} loading="lazy" />
                                            <span className="brave-collection-cta">
                                                Shop Now <i className="fa-regular fa-arrow-right-long"></i>
                                            </span>
                                        </Link>
                                    ))}
                                </div>
                            </section>

                            <div className="top-selling-area pb-100">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xxl-12">
                                            <div className="section-title top-selling-title text-center pb-47">
                                                <h3 className="p-title pb-15 mb-0">Best Sellers</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pb-20">
                                        {topSellingProducts &&
                                            topSellingProducts.map((product) => (
                                                <ProductCard key={product._id} product={product} />
                                            ))}
                                    </div>
                                    <div className="row">
                                        <div className="col-xxl-12">
                                            <div className="btn-area text-center wow fadeInUp" data-wow-delay="1.2s">
                                                <div className="p-btn p-btn-1">
                                                    <a href="/Shop">SHOW ALL PRODUCTS</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="banner-area pb-95 d-none">
                                <div className="pl-15 pr-15">
                                    <div className="row">
                                        <div className="col-xxl-6 col-lg-6 col-md-6 ps-0">
                                            <div className="single-banner single-banner-2 p-rel fix mb-30 mb-md-0 wow">
                                                <div className="thumb">
                                                    <img src={banner_banner_3} className=" wow fadeInRight h-100"
                                                        data-wow-delay=".10s" alt="#" />
                                                </div>
                                                <div className="banner-content banner-content-2 wow fadeInLeft" data-wow-delay=".10s">
                                                    <span>For women products</span>
                                                    <h4><a href="/Shop">Premium Travel Backpack</a></h4>
                                                    <p>Price guarantee. Found it cheaper - we'll match</p>
                                                    <div className="p-btn p-btn-2">
                                                        <a href="/Shop">SHOP COLLECTION</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-6 col-lg-6 col-md-6 pe-0">
                                            <div className="single-banner single-banner-2 p-rel fix wow fadeInRight" data-wow-delay=".15s">
                                                <div className="thumb ">
                                                    <img src={banner_banner_4} className=" wow fadeInRLeft h-100"
                                                        data-wow-delay=".10s" alt="#" />
                                                </div>
                                                <div className="banner-content banner-content-2  wow fadeInLeft" data-wow-delay=".15s">
                                                    <span>TRENDING PRODUCTS</span>
                                                    <h4><a href="/Shop">Lifestyle Accessories Parrot</a></h4>
                                                    <p>Secure & encrypted checkout</p>
                                                    <div className="p-btn p-btn-2">
                                                        <a href="/Shop">SHOP COLLECTION</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <DiscountPopup />

                            <div className="subscribe-area subscribe-area-2 black-bg gray-bg-2 pt-95 d-none">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xxl-12">
                                            <div className="section-title text-center">
                                                <span className="p-subtitle p-subtitle-2">OUR NEWSLETTER</span>
                                                <h3 className="p-title pb-15 mb-0">join our newsletter</h3>
                                                <p className="p-desc  pb-15">Subscribe to the Puik Store mailing list to receive updates on new
                                                    arrivals, special offers<br />
                                                    and other discount information.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col-xxl-8 col-xl-8">
                                            <div className="subscribe-form text-center">
                                                <form action="#">
                                                    <input type="text" placeholder="Your email address..."></input>
                                                    <button type="submit" className="subscribe-btn subscribe-btn-2">Subscribe</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="product__modal-area modal fade" id="productModal" tabIndex="-1" role="dialog" aria-labelledby="productModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="product__modal-inner position-relative">
                                            <div className="product__modal-close">
                                                <button data-bs-dismiss="modal" aria-label="Close">
                                                    <i className="ti-close"></i>
                                                </button>
                                            </div>
                                            <div className="product__modal-left">
                                                <div className="tab-content mb-10" id="productModalThumb">
                                                    <div className="tab-pane fade show active" id="pro-1" role="tabpanel" aria-labelledby="pro-1-tab">
                                                        <div className="product__modal-thumb w-img">
                                                            <img src={product_modal_1} alt=""></img>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="pro-2" role="tabpanel" aria-labelledby="pro-2-tab">
                                                        <div className="product__modal-thumb w-img">
                                                            <img src={product_modal_2} alt=""></img>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="pro-3" role="tabpanel" aria-labelledby="pro-3-tab">
                                                        <div className="product__modal-thumb w-img">
                                                            <img src={product_modal_1} alt=""></img>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="pro-4" role="tabpanel" aria-labelledby="pro-4-tab">
                                                        <div className="product__modal-thumb w-img">
                                                            <img src={product_modal_2} alt=""></img>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="product__modal-nav">
                                                    <ul className="nav nav-tabs" id="productModalNav" role="tablist">
                                                        <li className="nav-item mr-10" role="presentation">
                                                            <button className="nav-link active" id="pro-1-tab" data-bs-toggle="tab" data-bs-target="#pro-1" type="button" role="tab" aria-controls="pro-1" aria-selected="true">
                                                                <img src={product_modal_sm_2} alt=""></img>
                                                            </button>
                                                        </li>
                                                        <li className="nav-item mr-10" role="presentation">
                                                            <button className="nav-link" id="pro-2-tab" data-bs-toggle="tab" data-bs-target="#pro-2" type="button" role="tab" aria-controls="pro-2" aria-selected="false">
                                                                <img src={product_modal_sm_1} alt=""></img>
                                                            </button>
                                                        </li>
                                                        <li className="nav-item mr-10" role="presentation">
                                                            <button className="nav-link" id="pro-3-tab" data-bs-toggle="tab" data-bs-target="#pro-3" type="button" role="tab" aria-controls="pro-3" aria-selected="false">
                                                                <img src={product_modal_sm_2} alt=""></img>
                                                            </button>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <button className="nav-link" id="pro-4-tab" data-bs-toggle="tab" data-bs-target="#pro-4" type="button" role="tab" aria-controls="pro-4" aria-selected="false">
                                                                <img src={product_modal_sm_1} alt=""></img>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="product__modal-right">
                                                <h3 className="product__modal-title">
                                                    <a href="/Shop" aria-label="Shop"></a>
                                                </h3>
                                                <div className="product__modal-rating d-flex align-items-center">
                                                    <ul className="mr-10">
                                                        <li>
                                                            <a href="#!"><i className="ti-star"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="ti-star"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="ti-star"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="ti-star"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="ti-star"></i></a>
                                                        </li>
                                                    </ul>
                                                    <div className="customer-review">
                                                        <a href="#!">(1 customer review)</a>
                                                    </div>
                                                </div>
                                                <div className="product__modal-price mb-10">
                                                    <span className="price new-price">$700.00 &nbsp;</span>

                                                    <span className="price old-price">$899.99</span>
                                                </div>
                                                <div className="product__modal-available">
                                                    <p> Availability: <span>In Stock</span> </p>
                                                </div>
                                                <div className="product__modal-sku">
                                                    <p> Sku: <span> 0026AG90-1</span> </p>
                                                </div>
                                                <div className="product__modal-des">
                                                    <p>Typi non habent claritatem insitam, est usus legentis in iis qui facit eorum claritatem. Investigationes demonstraverunt lectores legere me lius quod legunt saepius.…</p>
                                                </div>
                                                <div className="product__modal-quantity mb-15">
                                                    <h5>Quantity:</h5>
                                                    <form action="#">
                                                        <div className="pro-quan-area d-sm-flex align-items-center">
                                                            <div className="product-quantity mr-20 mb-25">
                                                                <div className="cart-plus-minus p-relative"><input type="text" value="1" /></div>
                                                            </div>
                                                            <div className="product__modal-cart mb-25">
                                                                <button className="product-modal-cart-btn " type="submit">Add to cart</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="product__modal-categories d-sm-flex align-items-center">
                                                    <span>Categories: </span>
                                                    <ul>
                                                        <li><a href="#!">Decor, </a></li>
                                                        <li><a href="#!">Lamp, </a></li>
                                                        <li><a href="#!">Lighting</a></li>
                                                    </ul>
                                                </div>
                                                <div className="product__modal-categories d-sm-flex align-items-center">
                                                    <span>Tags: </span>
                                                    <ul>
                                                        <li><a href="#!">Furniture, </a></li>
                                                        <li><a href="#!">Lighting, </a></li>
                                                        <li><a href="#!">Living Room, </a></li>
                                                        <li><a href="#!">Table</a></li>
                                                    </ul>
                                                </div>
                                                <div className="product__modal-share d-sm-flex align-items-center">
                                                    <span>Share this product: </span>
                                                    <ul>
                                                        <li>
                                                            <a href="#!"><i className="fab fa-facebook-f"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="fab fa-twitter"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="fab fa-pinterest-p"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="fab fa-google-plus-g"></i></a>
                                                        </li>
                                                        <li>
                                                            <a href="#!"><i className="fab fa-linkedin-in"></i></a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="subscribe-popup d-none">
                                <div className="subscribe-wrapper s-popup-padding h-100">
                                    <div className="pl-75 pr-75">
                                        <div className="row">
                                            <div className="col-xxl-6">
                                                <div className="subscribe-content">
                                                    <div className="logo mb-65">
                                                        <a href="/"><img src={bravelogo} alt="" /></a>
                                                    </div>
                                                    <h4 className="popup-title">Comming Soon</h4>
                                                    <p className="popup-desc">We’ll be here soon with our new<br />
                                                        awesome site, subscribe to be notified.</p>
                                                    <div className="comming-countdown  pb-45">
                                                        <div className="countdown-inner" data-countdown="" data-date="Mar 02 2024 20:20:22">
                                                            <ul>
                                                                <li><span data-days="">401</span> Days</li>
                                                                <li><span data-hours="">1</span> hours</li>
                                                                <li><span data-minutes="">29</span> mins</li>
                                                                <li><span data-seconds="">40</span> secs</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="subscribe-form-2 mb-30">
                                                        <input type="email" placeholder="Enter your email..."></input>
                                                        <button className="p-btn border-0">Subscribe</button>
                                                    </div>
                                                    <div className="popup-social">
                                                        <a href="#!"><i className="fab fa-facebook-f"></i></a>
                                                        <a href="#!"><i className="fab fa-twitter"></i></a>
                                                        <a href="#!"><i className="fab fa-instagram"></i></a>
                                                        <a href="#!"><i className="fab fa-google-plus-g"></i></a>
                                                        <a href="#!"><i className="fal fa-basketball-ball"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subscribe-thumb"></div>
                            </div>

                        </main>

                    </div>


                </Fragment>
            )}
        </Fragment>
    );
}

export default Home;
